import { VStack, Box } from '@chakra-ui/react'
import { useJumpLastUrl } from '@!/Hooks'
import { GoBackButton } from '@!/components/Button/GoBackButton'

const BookPurchaseError = ({ errorMessage }) => {
  const jumpLastUrl = useJumpLastUrl()

  return (
    <VStack py="30px">
      <Box fontWeight="bold">{errorMessage}</Box>
      <GoBackButton onClick={jumpLastUrl}>購入ページに戻る</GoBackButton>
    </VStack>
  )
}

export default BookPurchaseError
